import { Box, Center, Flex, Link } from "@chakra-ui/react";
import { useContext } from "react";
import { TenantContext } from "../shared/contexts/tenantContext";
import { OnlineDoctorIcon } from "./icons/OnlineDoctorIcon";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const Header: React.FC = () => {
  const tenantConfig = useContext(TenantContext);
  return (
    <Box as="header" boxShadow="sm" width="full" zIndex={1}>
      <Flex
        direction="row"
        backgroundColor="white"
        alignItems="center"
        justifyContent="space-between"
        padding={2}
        paddingLeft={8}
        height={{ base: "58px", xl: "68px" }}
      >
        <Center width={{ base: "62px", xl: "82px" }} marginX={2}>
          <Link href={tenantConfig.links.homePage}>
            <OnlineDoctorIcon height={8} width="auto" color="primary.500" />
          </Link>
        </Center>
        {tenantConfig.enabledPatientLocales.length > 1 && (
          <Center marginX={2}>
            <LanguageSwitcher />
          </Center>
        )}
      </Flex>
    </Box>
  );
};
